import { render, staticRenderFns } from "./Recette.vue?vue&type=template&id=6b80d01a"
import script from "./Recette.vue?vue&type=script&lang=js"
export * from "./Recette.vue?vue&type=script&lang=js"
import style0 from "./Recette.vue?vue&type=style&index=0&id=6b80d01a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports